import { useContext } from 'react';
import { DownloadManagerContext, DownloadManagerHandlerProps } from 'services/DownloadManager';
import { Stack } from '@mui/material';
import { Highcharts } from 'components/chart/Chart';

export type DownloadFormatType = 'csv' | 'csvf' | 'xlsx' | 'pdf' | 'pptx';
function DownloadLink({
    children,
    downloadOptions,
    options,
    childRef,
}: {
    children: any;
    downloadOptions: DownloadManagerHandlerProps;
    options?: any;
    childRef?: React.Ref<HTMLElement>;
}) {
    const downloadHandler = useContext(DownloadManagerContext);
    const callDownloadManager = function () {
        if (Array.isArray(Highcharts?.charts)) {
            const chart = Highcharts?.charts.filter((c) => c != undefined)?.[0];
            if (chart) {
                const extremes = chart.xAxis[0].getExtremes();
                if (extremes?.userMin && extremes?.userMax) {
                    if (options == undefined) {
                        options = {};
                    }
                    options.range_start = extremes.userMin;
                    options.range_end = extremes.userMax;
                }
            }
        }

        downloadHandler(downloadOptions, options);
    };

    return (
        <Stack
            ref={childRef as React.Ref<HTMLDivElement>}
            direction={'row'}
            alignItems={'center'}
            onClick={callDownloadManager}
        >
            {children}
        </Stack>
    );
}

export function DownloadLinkElement({
    children,
    elementId,
    segmentValueId,
    format,
    uco,
    filters,
    reference,
    useNativeFilters,
    childRef,
}: {
    children: any;
    elementId: number;
    segmentValueId: number;
    format: string;
    uco?: number;
    filters?: string;
    reference?: string;
    useNativeFilters?: boolean;
    childRef?: React.Ref<HTMLElement>;
}) {
    const props = {
        elementId: elementId,
        segmentId: segmentValueId,
        format: format,
    };

    let options: any = {};
    if (uco || filters || reference) {
        if (uco) {
            options.uco = uco;
        }
        if (filters) {
            options.filters = filters;
            options.use_native_filters = useNativeFilters ? 'Y' : 'N';
        }
        if (reference) {
            options.reference = reference;
        }
    } else {
        options = undefined;
    }

    return (
        <DownloadLink childRef={childRef} options={options} downloadOptions={props}>
            {children}
        </DownloadLink>
    );
}
